.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  display: block;
  margin: 0 auto;
  padding: 0 16px 20px;
  box-sizing: border-box;
  max-width: 1200px;
  overflow: visible;
  color: #626469;
  padding-bottom: 0;
  margin-top: 14px;
  margin-bottom: 24px;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  :host {
    padding: 0 10px;
  }
}

@media screen and (min-width: 980px) {
  :host {
    margin-top: 32px;
  }
}

.category-description__header {
  padding: 0;
}

.category-description__badge {
  margin-top: 16px;
}

@media screen and (min-width: 980px) {
  .category-description__badge {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 2px;
    vertical-align: text-bottom;
  }

  :host(:not([dir="rtl"])) .category-description__badge {
    margin-left: 24px;
  }

  :host([dir="rtl"]) .category-description__badge {
    margin-right: 24px;
  }
}

.category-description__header-title {
  display: block;
  margin: 0;
  font-size: 1.875rem;
  line-height: 2.5rem;
  font-weight: normal;
  margin-bottom: 16px;
}

@media screen and (min-width: 980px) {
  .category-description__header-title {
    display: inline;
    font-size: 2.625rem;
    line-height: 3rem;
  }
}